import s, { createContext as y, useContext as b } from "react";
import { createMercadoPagoSlice as i } from "../payment-processors/mercado-pago/slice/index.mjs";
import { devtools as v } from "../node_modules/zustand/esm/middleware.mjs";
import { createXenditSlice as x } from "../payment-processors/xendit/slice/xendit-slice.mjs";
import { createBaseSlice as K } from "./slices/base-slice.mjs";
import { createOfferSlice as h } from "./slices/offer-slice.mjs";
import { createPhysicalProductSlice as I } from "./slices/physical-product-slice.mjs";
import { createPublicKeysSlice as C } from "./slices/public-keys-slice.mjs";
import { createVisitorInfoSlice as g } from "./slices/visitor-info-slice.mjs";
import { create as M } from "../node_modules/zustand/esm/react.mjs";
const n = (e) => M()(
  v((o, t, r) => {
    const f = K(o, t, r, e == null ? void 0 : e.base), a = h(o, t, r, e == null ? void 0 : e.offer), S = g(o), m = C(o, t, r, e == null ? void 0 : e.publicKeys), d = I(
      o,
      t,
      r,
      e == null ? void 0 : e.physicalProduct
    );
    return {
      ...f,
      offer: a,
      publicKeys: m,
      xendit: x(o),
      physicalProduct: d,
      visitorInfo: S,
      mercadoPago: i(o)
    };
  })
);
let u = null;
const O = (e) => (u || (u = n(e)), u), l = y(null), V = () => b(l) ?? O(), c = () => V()(), A = () => {
  const { offer: e } = c();
  return e;
}, D = () => {
  const { publicKeys: e } = c();
  return e;
}, F = () => {
  const { xendit: e } = c();
  return e;
}, H = () => {
  const { visitorInfo: e } = c();
  return e;
}, J = () => {
  const { physicalProduct: e } = c();
  return e;
}, L = () => {
  const { mercadoPago: e } = c();
  return e;
};
function N({ children: e, initProps: o }) {
  const t = s.useMemo(() => n(o), [o]), r = typeof e == "function" ? e({ store: t }) : e;
  return s.createElement(l.Provider, { value: t }, r);
}
export {
  N as StoreProvider,
  n as createStore,
  L as useMercadoPagoStore,
  A as useOfferStore,
  J as usePhysicalProductStore,
  D as usePublicKeysStore,
  c as useStore,
  H as useVisitorInfoStore,
  F as useXenditStore
};
